import { Component, OnDestroy } from '@angular/core';
import { CleanSubscriptions } from './clean-subcriptions';

@Component({
  template:''
})
// tslint:disable-next-line: component-class-suffix
export class DefaultForm extends CleanSubscriptions implements OnDestroy {


  selectOnFocus($event: FocusEvent) {
    const inp: HTMLInputElement = $event.target as HTMLInputElement;
    inp.select();
  }


}
